import { SortationWidgetHelper } from '../content/contentBuilder/widgets/SortationWidget';
export const SortationQuestionWidgetConverter = {
    convertDomainModel: (serverData) => {
        var _a, _b, _c, _d;
        const data = {
            id: serverData.id,
            trackingIdentifier: serverData.trackingIdentifier,
            optionsCorrectOrder: serverData.data.optionsCorrectOrder,
            question: serverData.data.question,
        };
        const properties = {
            isRequired: (_a = serverData.properties.isRequired) !== null && _a !== void 0 ? _a : false,
            displayDelayInSeconds: (_b = serverData.properties.displayDelayInSeconds) !== null && _b !== void 0 ? _b : 0,
            revealAnswers: (_c = serverData.properties.revealAnswers) !== null && _c !== void 0 ? _c : true,
            repeatUntilCorrect: (_d = serverData.properties.repeatUntilCorrect) !== null && _d !== void 0 ? _d : true,
        };
        return SortationWidgetHelper.create(data, properties);
    },
    // no need to convert to server model
};
